import React from 'react';
import Header from '../../ui/Header';
import HeroSection from '../../ui/HeroSection';

const Home = () => {
  return (
    <>
      <Header />
      <HeroSection />
    </>
  );
};

export default Home;